/** @file Generic prompt dialog (returns string or null). */
import { h } from "./dom.js";
import { openModal } from "./modal.js";

/**
 * @param {{ title: string, initial?: string, maxLength?: number, placeholder?: string }} opts
 * @returns {Promise<string | null>}
 */
export function openPromptDialog(opts) {
  const { title, initial = "", maxLength = 80, placeholder = "" } = opts;
  return openModal((close) => {
    const input = /** @type {HTMLInputElement} */ (
      h("input", {
        type: "text",
        value: initial,
        maxLength,
        placeholder,
        class: "hb-auth-input",
      })
    );
    const submit = h("button", { type: "submit", class: "hb-btn hb-btn--primary min-h-11" }, [
      "OK",
    ]);
    const cancel = h("button", { type: "button", class: "hb-btn min-h-11" }, ["Abbrechen"]);
    cancel.addEventListener("click", () => close(null));
    const form = h("form", { class: "flex flex-col gap-3" }, [
      h("h2", { class: "text-xl font-bold" }, [title]),
      input,
      h("div", { class: "flex gap-2 justify-end mt-2" }, [cancel, submit]),
    ]);
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      const v = input.value.trim();
      if (!v) {
        return;
      }
      close(v);
    });
    setTimeout(() => {
      input.focus();
      input.select();
    }, 0);
    return form;
  });
}
